import { FormattedMessage } from 'react-intl'
import { Icon } from '@starbucks-web/pattern-library'
import { trackSettingsItemClick } from '../../../state/track-event.js'

const AboutListItem = ({ text, icon, link, linkProps }) => (
  <a
    className={`flex justify-between py3 text-noUnderline color-textBlackSoft text-sm`}
    href={link}
    onClick={() => {
      trackSettingsItemClick({
        click_target: text?.defaultMessage,
      })
    }}
    {...linkProps}
  >
    <FormattedMessage {...text} />
    <Icon path={icon} size="22px" />
  </a>
)

export default AboutListItem
